/**
 * Generated by orval v8.6.2 🍺
 * Do not edit manually.
 * Marketplace API
 * OpenAPI spec version: 1.0.0
 */

/**
 * * `FIXED` - Fixed
* `INDEX` - Index
 */
export type PricingTypeEnum = typeof PricingTypeEnum[keyof typeof PricingTypeEnum];


export const PricingTypeEnum = {
  FIXED: 'FIXED',
  INDEX: 'INDEX',
} as const;
